import { IApplicationState } from '../../types/redux';

export function selectMenuStatus(state: IApplicationState) {
  return state.menu.open;
}
